import script from "./AdminFAB.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFAB.vue?vue&type=script&setup=true&lang=js"

import "./AdminFAB.vue?vue&type=style&index=0&id=6d6082d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6082d2"]])

export default __exports__